module.exports = __webpack_public_path__ + "static/media/edit.bd8dbe63.svg";